/* Predictive search header */
import gsap from "gsap";
import { debounce } from "lodash";
import { makeHeaderRed, makeHeaderTransparent } from "./header";
import {
  showAnnouncementBar,
  hideAnnouncementBar,
} from "../snippets/dropdown-menu-v2";

export function getSearchDropdownHeight() {
  const announcementBar = document.querySelector("#announcement-bar-container");
  let announcementBarHeight = "0px";

  if (announcementBar instanceof HTMLElement) {
    announcementBarHeight = "30px";
  }

  return `calc(100% - var(--header-height, 80px) + ${announcementBarHeight})`;
}

export function search(searchButtonElement) {
  let searchOpen = false;

  const searchContainerOverlay = document.querySelector(
    ".search-container-overlay"
  );
  const searchContainer = document.getElementById("search-container");

  const headerButtons = Array.from(
    document.querySelectorAll(
      ".menu-toggle-button, .header-search-button, .header-currency-button, .header-account-link, .header-minicart-button"
    )
  );
  const closeSearchButton = document.querySelector(
    ".header-close-search-button"
  );
  const inputElement = searchContainer.querySelector('input[type="search"]');

  let tl = gsap
    .timeline({
      //  repeatRefresh: true,
      paused: true,
      onStart: () => {
        searchContainer.classList.remove("hidden");
        // hide announcement bar
        hideAnnouncementBar(searchContainerOverlay, searchContainer);
      },
      onComplete: () => {
        searchOpen = true;
        makeHeaderRed();
        // @ts-ignore
        inputElement.focus();
      },
      onReverseComplete: () => {
        searchContainer.classList.add("hidden");
        searchOpen = false;
        makeHeaderTransparent();
        clearInput(inputElement);

        // TODO clear search results?

        tl.invalidate(); //avoid using resize event to recalculate the height
        // hide announcement bar
        showAnnouncementBar(searchContainerOverlay, searchContainer);
      },
    })
    .set(searchContainer, { height: "0px" })
    .set(searchContainerOverlay, { height: "100%", opacity: 0 })
    .to(searchContainerOverlay, {
      opacity: 1,
      duration: 0.2,
    })
    .to(searchContainer, {
      height: getSearchDropdownHeight,
      duration: 0.2,
    });

  // Close search
  closeSearchButton.addEventListener("click", () => {
    // Hide X button
    // @ts-ignore
    closeSearchButton.style.display = "none";
    // Show other buttons
    for (let el of headerButtons) {
      if (el instanceof HTMLElement) {
        el.style.visibility = "visible";
        el.style.pointerEvents = "all";
      }
    }

    tl.reverse();
  });

  // Open search
  searchButtonElement.onclick = () => {
    // Show X button
    // @ts-ignore
    closeSearchButton.style.display = "grid";
    // Hide other buttons
    for (let el of headerButtons) {
      if (el instanceof HTMLElement) {
        el.style.visibility = "hidden";
        el.style.pointerEvents = "none";
      }
    }

    tl.play();

    // @ts-ignore
    handleSearchInput(inputElement, handlePredictiveSearch);
  };

  // Close on overlay click
  searchContainerOverlay.addEventListener("click", (e) => {
    if (e.target !== e.currentTarget) {
      return;
    } else {
      // Hide X button
      // @ts-ignore
      closeSearchButton.style.display = "none";
      // Show other buttons
      for (let el of headerButtons) {
        if (el instanceof HTMLElement) {
          el.style.visibility = "visible";
          el.style.pointerEvents = "all";
        }
      }

      tl.reverse();
    }
  });
}

function clearInput(inputElement) {
  if (inputElement instanceof HTMLInputElement) {
    inputElement.value = "";
  }
}
/**
 * @param {HTMLElement} inputElement
 * @param {(arg: string) => void} handleSearch
 */
function handleSearchInput(inputElement, handleSearch) {
  if (!(inputElement instanceof HTMLElement)) return;

  inputElement.addEventListener(
    "input",
    debounce((e) => {
      const searchTerm = e.target.value.trim();
      handleSearch(searchTerm);
    }, 300)
  );
}

/**
 * @param {string} searchTerm
 */
function handlePredictiveSearch(searchTerm) {
  fetch(
    `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=6&section_id=search`
  )
    .then((response) => {
      if (!response.ok) {
        let error = new Error(`${response.status}`);
        // @ts-ignore
        console.error(response.message);
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#predictive-search-results").innerHTML;
      const predictiveSearchResults = document.getElementById(
        "predictive-search-results"
      );
      predictiveSearchResults.innerHTML = resultsMarkup;
    })
    .catch((error) => {
      console.log(error.message);
      throw error;
    });
}
